var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconsXls(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    d: "M19 21H5c-.552 0-1-.448-1-1V4c0-.552.448-1 1-1h9.092L20 9.751V20c0 .552-.448 1-1 1zm3-12l-7-8H5C3.343 1 2 2.343 2 4v16c0 1.657 1.343 3 3 3h14c1.657 0 3-1.343 3-3V9zm-10.798 3.525L9.049 9l2.153 3.525L9 16.11l2.202-3.584zm.767-.957L13.463 9l-1.494 2.568zm0 1.934l1.528 2.607-1.528-2.607zm0 .494l-1.39 2.363H8.552l2.356-3.834L8.603 8.75h2.015l1.35 2.321 1.35-2.321h2.016l-2.301 3.775 2.35 3.834h-2.03l-1.385-2.363z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsXls);
export default __webpack_public_path__ + "static/media/Icons_Xls.61cecc47fcf5e11af906425342590a72.svg";
export { ForwardRef as ReactComponent };